import { render, staticRenderFns } from "./BranchManagement.vue?vue&type=template&id=429cf528&lang=pug"
import script from "./BranchManagement.vue?vue&type=script&lang=ts"
export * from "./BranchManagement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports